module.exports = __webpack_public_path__ + "static/media/kitegateway_icon_all.8f63192d.png";